<template>
  <AccessData />
</template>

<script>
export default {
  name: "AccessDataPage",
  components: {
    AccessData: () => import("@/components/templates/AccessData.vue"),
  },
};
</script>

<style></style>
